import React from "react";

import {
    Box,
    CircularProgress
} from "@mui/material";

export default class ZPlayFullPageLoader extends React.Component<{}, {}>
{

    render() {
        return (<Box
            sx={{
                width: "100vw",
                position: "absolute",
                top: 0,
                color: "white",
                backgroundColor: "black",
                display: "flex",
                flex: "1",
                justifyContent: "center",
                alignContent: "center",
                height: "100vw",
                zIndex: (theme) => theme.zIndex.drawer + 99
            }}>
            <CircularProgress color="inherit" size="7rem" />
        </Box>);
    }
}
